import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router/router'
import store from './store/store'
import Tabs from 'vue3-tabs'
import VueFinalModal from 'vue-final-modal'
import VueGtag from "vue-gtag-next";



const app = createApp(App);

import AOS from 'aos'
import 'aos/dist/aos.css'
app.AOS = new AOS.init({ duration: 1000 })


app
    .use(router)
    .use(store)
    .use(Tabs)
    .use(VueFinalModal())
    .use(
        VueGtag,
        {
            property: {
                id: "G-PJ4XNYJTPJ",
            },
        },
        router // IMPORTANT: enables automatic page tracking
    )
    .mount("#app");
